<script setup lang="ts">
import DisciplineDetailMenu from '../DisciplineDetailMenu.vue'
import LessonCustomerTimezone from './LessonCustomerTimezone.vue'

defineOptions({
  name: 'LessonsDetailMenu',
})
</script>

<template>
  <div class="lessons-detail-menu">
    <DisciplineDetailMenu />
    <LessonCustomerTimezone />
  </div>
</template>

<style scoped lang="scss" src="./LessonsDetailMenu.scss" />
